import { JobStatusEnum } from '../job/useJob';

/**
 * Content datasets that can be refreshed via blue-green deployment.
 * Mirrors the backend ContentIngestionType enum.
 */
export enum ContentRefreshType {
  OBLIGATION_RULES = 'OBLIGATION_RULES',
  FOLDER_TAXONOMY = 'FOLDER_TAXONOMY',
  DOCUMENT_ROUTING = 'DOCUMENT_ROUTING',
  IDENTITY_DOCUMENTS = 'IDENTITY_DOCUMENTS',
  ENTITY_MANAGEMENT = 'ENTITY_MANAGEMENT',
}

export type TRefreshContentParams = {
  contentType: ContentRefreshType;
  token?: string;
};

export type TContentRefreshTriggeredBy = {
  id: string;
  name: string | null;
  email: string | null;
};

export type TContentRefreshHistoryItem = {
  jobId: string;
  contentType: ContentRefreshType | null;
  status: JobStatusEnum;
  createdAt: string | null;
  finishedAt: string | null;
  errorMessage: string | null;
  triggeredBy: TContentRefreshTriggeredBy | null;
};

export type TContentRefreshHistoryResponse = {
  history: TContentRefreshHistoryItem[];
};

export type TRefreshContentResponse = {
  job: {
    id: string;
    message: string;
  };
};

export const REFRESH_FLAG_BY_CONTENT_TYPE: Record<ContentRefreshType, string> = {
  [ContentRefreshType.OBLIGATION_RULES]: 'refreshFilingsContent',
  [ContentRefreshType.FOLDER_TAXONOMY]: 'refreshFolderTaxonomyContent',
  [ContentRefreshType.DOCUMENT_ROUTING]: 'refreshDocumentRoutingContent',
  [ContentRefreshType.IDENTITY_DOCUMENTS]: 'refreshIdentityDocumentsContent',
  [ContentRefreshType.ENTITY_MANAGEMENT]: 'refreshEntityManagementContent',
};
